import _ from 'lodash';

const englishMinuteAudioPaths = [
    "1MinuteHeyGuys.mp3",
    "1MinuteHolaHola.mp3",
    "1MinuteHowIs.mp3",
    "1MinuteShout.mp3"
];
  
export function randomEnglishMinuteAudioPath() {
    return _.sample(englishMinuteAudioPaths);
};

const englishSecondAudioPaths = [
    "10SecondsHurryUp.mp3",
    "10SecondsOhNo.mp3",
    "10SecondsSexy.mp3",
    "10SecondsTimeIsAlmostUp.mp3"
];

export function randomEnglishSecondAudioPath() {
    return _.sample(englishSecondAudioPaths);
};